// src/components/WishlistButton.tsx
//
// Heart toggle for a product. Used on product cards (floating over the image)
// and on the product page. Stops event propagation so tapping the heart never
// also opens the card underneath it.

import React from "react";
import { useWishlist } from "../contexts/WishlistContext";

type WishlistButtonProps = {
  productId?: string | null;
  className?: string;
};

const WishlistButton: React.FC<WishlistButtonProps> = ({
  productId,
  className,
}) => {
  const { isInWishlist, toggleWishlist } = useWishlist();
  const active = isInWishlist(productId);

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        toggleWishlist(productId);
      }}
      aria-label={active ? "Remove from wishlist" : "Add to wishlist"}
      aria-pressed={active}
      title={active ? "Remove from wishlist" : "Add to wishlist"}
      className={`transition ${className ?? ""}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill={active ? "#dc2626" : "none"}
        stroke={active ? "#dc2626" : "currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-5 w-5"
      >
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    </button>
  );
};

export default WishlistButton;
